import React from 'react';
import HeaderSortableColumn from './HeaderSortableColumn';

interface TableHeaderProps {
  isChecked: boolean;
  onCheckboxAllClick: () => void;
  isOperatorView?: boolean;
}

const TableHeader = (props: TableHeaderProps) => {
  const [isChecked, setIsChecked] = React.useState(props.isChecked);

  function toggleChecked(): void {
    props.onCheckboxAllClick();
  }

  React.useEffect(() => {
    setIsChecked(props.isChecked);
  }, [props.isChecked]);

  return (
    <thead>
      <tr>
        {true && (
          <th>
            <td onClick={() => toggleChecked()}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => toggleChecked()}
                className="i-checks"
              />
            </td>
          </th>
        )}
        <HeaderSortableColumn column={'task_id'} label={'Task ID'} />
        <th title="Order ID">OrdID</th>
        <th title="Project ID">ProjID</th>
        <th title="Project Name">ProjName</th>
        <th>Impregnation</th>
        <th>Walls thickness</th>
        {!props.isOperatorView && <th title="Customer">Customer</th>}
        <HeaderSortableColumn column={'task_type'} label={'Task Type'} />
        <HeaderSortableColumn column={'machine'} label={'Machine'} />
        <HeaderSortableColumn
          column={'operator_name'}
          label={'Operator Name'}
        />
        <HeaderSortableColumn column={'prod_deadline'} label={'Prod Deadline'} />
        <HeaderSortableColumn column={'priority'} label={'Priority'} />
        <HeaderSortableColumn column={'status'} label={'Status'} />
        <th>Task Completion Duration</th>
        <th>m<sup>3</sup></th>
      </tr>
    </thead>
  );
};

export default TableHeader;
